var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 3.46484L11.3248 4.15484L6.56977 8.89484C6.19289 9.27172 6.19289 9.88297 6.56977 10.2598C6.94664 10.6367 7.55789 10.6367 7.93477 10.2598L11.0398 7.13984V19.1998C11.0341 19.5467 11.216 19.8673 11.516 20.0417C11.8141 20.218 12.1854 20.218 12.4835 20.0417C12.7835 19.8673 12.9654 19.5467 12.9598 19.1998V7.13984L16.0648 10.2598C16.4416 10.6367 17.0529 10.6367 17.4298 10.2598C17.8066 9.88297 17.8066 9.27172 17.4298 8.89484L12.6748 4.15484L11.9998 3.46484Z",
    fill: "#58B5AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/increase-icon.3b86f5da0d8580b1b7765a2a92de7579.svg";
export { ForwardRef as ReactComponent };